import { memo } from "react";

import { Text } from "@/components/atoms/Text";
import { Stack } from "@/components/atoms/Stack";
import type { TextVariant } from "@/components/atoms/types";
import { ifWeb } from "@/utils/platform";

/**
 * View component that renders empty state message when no similar players are found.
 */
const ListEmptyView = () => (
  <Stack className="h-full items-center justify-center gap-3 pt-5">
    <Text
      variant={ifWeb<TextVariant>("title-sm", "display-sm")}
      className="text-center"
    >
      No Similar Players
    </Text>
    <Text
      variant="unstyled"
      className={`text-center font-medium ${ifWeb("text-body", "text-title-sm")} text-content-muted`}
    >
      We could not find any similar players for this player.
    </Text>
  </Stack>
);

ListEmptyView.displayName = "ListEmptyView";

export default memo(ListEmptyView);
